import './about-us-info-row.styles.css';

const AboutUsInfoRow = ({cat , className}) => {
  return (
    <div className={`about-us-info-row-box ${className}`}>
        <div className="about-us-info-text-box">
            <h3 className='about-us-info-title'>
                {cat.title}
            </h3>

            <p className="about-us-info-text">
                {cat.text}
            </p>
        </div>
        <img src={cat.img} alt="img" className="aobut-us-info-img"/>
    </div>
  )
}

export default AboutUsInfoRow;